import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not yet converted to GTS }}",{ moduleName: "garaje/pods/visitors/settings/email-templates/show/index/template.hbs" })